<template>
  <div class="layouts-filter-controls">
    <div
      id="reports-search-input"
      class="layouts-filter-controls__search"
    >
      <div class="input-group">
        <input
          v-model="search"
          type="text"
          class="form-control"
          placeholder="Search..."
          @input="emitFiltersDebounced"
        >
        <button
          v-if="search"
          type="button"
          class="btn layouts-filter-controls__search-clear"
          @click="clearSearch"
        >
          <i class="bi bi-x" />
        </button>
        <div class="input-group-append">
          <div
            id="searchSettings"
            ref="settingsDropdown"
            class="dropdown layouts-filter-controls__search-settings"
          >
            <button
              ref="settingsButton"
              class="btn layouts-top__icon-btn"
              type="button"
              @click.stop="toggleSettings"
            >
              <i class="bi bi-sliders" />
            </button>
            <form
              v-show="settingsOpen"
              class="dropdown-menu show pt-3 px-3 pb-0"
              @click.stop
            >
              <div class="mb-3">
                <h6 style="color: #495057;">
                  Search in
                </h6>
              </div>
              <div class="form-group form-check">
                <label class="form-check-label cursor-pointer">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    checked
                    disabled
                  >
                  Layouts
                </label>
              </div>
              <div class="form-group form-check">
                <label class="form-check-label cursor-pointer">
                  <input
                    v-model="searchProjects"
                    type="checkbox"
                    class="form-check-input"
                    @change="emitFilters"
                  >
                  Projects
                </label>
              </div>
              <div class="form-group form-check">
                <label class="form-check-label cursor-pointer">
                  <input
                    v-model="searchProductId"
                    type="checkbox"
                    class="form-check-input"
                    @change="emitFilters"
                  >
                  Product ID
                </label>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div
      id="filterDropdown"
      ref="filtersDropdown"
      class="dropdown ml-2"
    >
      <button
        class="btn btn-primary dropdown-toggle"
        type="button"
        @click.stop="filtersOpen = !filtersOpen"
      >
        <i class="bi bi-funnel" /> Filters
      </button>
      <div
        v-show="filtersOpen"
        class="dropdown-menu dropdown-menu-right lm-filters show"
        @click.stop
        @mousedown.stop
      >
        <div class="lm-filters__body">
          <div class="lm-filters__toggles">
            <div>
              <label class="form-check-label cursor-pointer mb-0">
                <input
                  v-model="showQaLayouts"
                  type="checkbox"
                  class="form-check-input"
                  @change="emitFilters"
                >
                Show QA layouts
              </label>
            </div>
            <div>
              <label class="form-check-label cursor-pointer mb-0">
                <input
                  v-model="showOnlyFavorites"
                  type="checkbox"
                  class="form-check-input"
                  @change="emitFilters"
                >
                Favorites
              </label>
            </div>
            <div>
              <label class="form-check-label cursor-pointer mb-0">
                <input
                  v-model="hideEmptyLayouts"
                  type="checkbox"
                  class="form-check-input"
                  @change="emitFilters"
                >
                Hide empty layouts
              </label>
            </div>
          </div>

          <div class="form-group align-items-center lm-filters__row">
            <label class="mb-0 cursor-pointer">ID</label>
            <div>
              <input
                v-model="otherFilters['ID']"
                type="text"
                class="form-control w-100"
                @input="emitFiltersDebounced"
              >
            </div>
          </div>

          <div class="form-group align-items-center lm-filters__row">
            <label class="mb-0 cursor-pointer">Customer</label>
            <div>
              <div
                ref="customerDropdown"
                class="layouts-customer-filter"
              >
                <button
                  type="button"
                  class="form-control layouts-customer-filter__button"
                  @click.stop="customersOpen = !customersOpen"
                >
                  <span>{{ selectedCustomersLabel }}</span>
                  <i class="bi bi-chevron-down" />
                </button>
                <div
                  v-show="customersOpen"
                  class="layouts-customer-filter__menu"
                  @click.stop
                  @mousedown.stop
                >
                  <div class="layouts-customer-filter__search">
                    <input
                      v-model.trim="customerSearch"
                      type="search"
                      class="form-control"
                      placeholder="Search customer..."
                    >
                  </div>
                  <label class="layouts-customer-filter__option">
                    <input
                      type="checkbox"
                      :checked="!selectedCustomers.length"
                      @change="selectAllCustomers"
                    >
                    <span>All layouts</span>
                  </label>
                  <label
                    v-for="customer in filteredCustomers"
                    :key="customer.id"
                    class="layouts-customer-filter__option"
                  >
                    <input
                      type="checkbox"
                      :value="String(customer.id)"
                      :checked="selectedCustomers.includes(String(customer.id))"
                      @change="toggleCustomer(customer.id, $event.target.checked)"
                    >
                    <span>{{ customer.name }}</span>
                  </label>
                  <div
                    v-if="!filteredCustomers.length"
                    class="layouts-customer-filter__empty"
                  >
                    No customers found
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-for="filter in textFilters.filter(f => f.label !== 'ID')"
            :key="filter.label"
            class="form-group align-items-center lm-filters__row"
          >
            <label class="mb-0 cursor-pointer">{{ filter.label }}</label>
            <div>
              <input
                v-model="otherFilters[filter.label]"
                type="text"
                class="form-control w-100"
                @input="emitFiltersDebounced"
              >
            </div>
          </div>

          <div class="form-group align-items-center lm-filters__row">
            <label class="mb-0 cursor-pointer">Sort by</label>
            <div
              class="d-flex"
              style="gap: 8px;"
            >
              <select
                v-model="sortBy"
                class="form-control"
                @change="onSortColumnChange"
              >
                <option value="">
                  Column
                </option>
                <option
                  v-for="col in sortColumns"
                  :key="col.value"
                  :value="col.value"
                >
                  {{ col.label }}
                </option>
              </select>
              <select
                v-model="sortOrder"
                class="form-control w-auto"
                :disabled="!sortBy"
                @change="emitFilters"
              >
                <option
                  value=""
                  disabled
                >
                  Order
                </option>
                <option value="asc">
                  Asc
                </option>
                <option value="desc">
                  Desc
                </option>
              </select>
            </div>
          </div>

          <div class="form-group align-items-center lm-filters__row">
            <label class="mb-0 cursor-pointer">Per page</label>
            <div>
              <select
                v-model.number="perPage"
                class="form-control w-50"
                @change="emitFilters"
              >
                <option
                  v-for="option in perPageOptions"
                  :key="option"
                  :value="option"
                >
                  {{ option }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="lm-filters__footer">
          <button
            type="button"
            class="btn btn-link p-0 lm-filters__clear"
            @click="clearAll"
          >
            Clear all
          </button>
          <div class="lm-filters__active">
            {{ activeFiltersCount }} active
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LayoutsFilterControls',
  props: {
    customers: {
      type: Array,
      default: () => [],
    },
    perPageOptions: {
      type: Array,
      default: () => [10, 25, 50],
    },
  },
  data() {
    return {
      search: '',
      searchProjects: true,
      searchProductId: true,
      showOnlyFavorites: false,
      hideEmptyLayouts: false,
      showQaLayouts: false,
      selectedCustomers: [],
      otherFilters: {
        ID: '',
        Name: '',
        Company: '',
        'Created By': '',
      },
      sortBy: '',
      sortOrder: '',
      sortColumns: [
        { label: 'ID', value: 'id' },
        { label: 'Name', value: 'name' },
        { label: 'Company', value: 'company_name' },
        { label: 'Activity', value: 'activity' },
        { label: 'Status', value: 'status' },
        { label: 'Approvals', value: 'approvals' },
        { label: 'Folders', value: 'folders' },
        { label: 'Created By', value: 'user_name' },
        { label: 'Created On', value: 'created_at' },
        { label: 'Last Updated', value: 'updated_at' },
        { label: 'Templates', value: 'number_of_templates' },
        { label: 'Customer', value: 'customer_name' },
      ],
      perPage: 10,
      filtersOpen: false,
      settingsOpen: false,
      customersOpen: false,
      customerSearch: '',
      debounceTimer: null,

    };
  },
  computed: {
    normalizedCustomers() {
      return (this.customers || [])
        .filter(customer => customer && customer.id)
        .map(customer => ({
          id: String(customer.id),
          name: customer.name || `Customer ${customer.id}`,
        }));
    },
    filteredCustomers() {
      const search = this.customerSearch.toLowerCase();
      if (!search) {
        return this.normalizedCustomers;
      }

      return this.normalizedCustomers.filter(customer => (
        customer.name.toLowerCase().includes(search)
      ));
    },
    textFilters() {
      return Object.keys(this.otherFilters).map(label => ({ label }));
    },
    selectedCustomersLabel() {
      if (!this.selectedCustomers.length) {
        return 'All layouts';
      }

      if (this.selectedCustomers.length === 1) {
        const selected = this.normalizedCustomers.find(customer => customer.id === this.selectedCustomers[0]);
        return selected?.name || '1 selected';
      }

      return `${this.selectedCustomers.length} selected`;
    },
    activeFiltersCount() {
      let count = 0;
      if (this.showOnlyFavorites) count += 1;
      if (this.hideEmptyLayouts) count += 1;
      if (this.showQaLayouts) count += 1;
      if (this.selectedCustomers.length) count += 1;
      Object.values(this.otherFilters).forEach(value => {
        if (String(value || '').trim()) count += 1;
      });
      if (Number(this.perPage) !== 10) count += 1;
      if (this.sortBy) count += 1;
      return count;
    },
  },
  mounted() {
    this.search = new URLSearchParams(window.location.search).get('filters[search]') || '';

    document.addEventListener('click', this.onDocumentClick);
    window.addEventListener('layouts-view-changed', this.emitCurrentState);

    this._sortResetUnsubscribe = window.livewire?.on('layoutsSortReset', () => {
      this.sortBy = '';
      this.sortOrder = '';
    });

    this.emitFilters();
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onDocumentClick);
    window.removeEventListener('layouts-view-changed', this.emitCurrentState);
    this._sortResetUnsubscribe?.();
    clearTimeout(this.debounceTimer);
  },
  methods: {
    toggleSettings() {
      this.settingsOpen = !this.settingsOpen;
      if (!this.settingsOpen) {
        this.$nextTick(() => this.$refs.settingsButton?.blur());
      }
    },
    activeLivewireComponentName() {
      if (window.location.hash === '#layout-proofs') {
        const proofThumbnailView = document.querySelector('.proof-thumbnail-view-container');
        const isProofThumbnailVisible = proofThumbnailView && window.getComputedStyle(proofThumbnailView).display !== 'none';
        return isProofThumbnailVisible ? 'thumbnail-proofs-list' : 'layout-proofs-table';
      }

      const thumbnailView = document.querySelector('.thumbnail-view-container');
      const isThumbnailVisible = thumbnailView && window.getComputedStyle(thumbnailView).display !== 'none';

      return isThumbnailVisible ? 'thumbnail-layout-list' : 'grid-layout-table';
    },
    emitToActiveLivewireComponent(eventName, payload) {
      if (!window.livewire?.emitTo) {
        window.livewire?.emit?.(eventName, payload);
        return;
      }

      window.livewire.emitTo(this.activeLivewireComponentName(), eventName, payload);
    },
    onSortColumnChange() {
      if (this.sortBy) {
        this.sortOrder = 'asc';
      } else {
        this.sortOrder = '';
      }
      this.emitFilters();
    },
    onDocumentClick(event) {
      if (this.$refs.filtersDropdown && !this.$refs.filtersDropdown.contains(event.target)) {
        this.filtersOpen = false;
        this.customersOpen = false;
      }

      if (this.$refs.settingsDropdown && !this.$refs.settingsDropdown.contains(event.target)) {
        this.settingsOpen = false;
      }
    },
    emitFiltersDebounced() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => this.emitFilters(), 350);
    },
    clearSearch() {
      clearTimeout(this.debounceTimer);
      this.search = '';
      this.emitToActiveLivewireComponent('layoutsVueSearchCleared');
    },
    emitFilters() {
      this.emitToActiveLivewireComponent('layoutsVueFiltersUpdated', {
        search: this.search,
        searchProjects: this.searchProjects,
        searchProductId: this.searchProductId,
        showOnlyFavorites: this.showOnlyFavorites,
        hideEmptyLayouts: this.hideEmptyLayouts,
        showQaLayouts: this.showQaLayouts,
        otherFilters: this.otherFilters,
        perPage: this.perPage,
        sortBy: this.sortBy,
        sortOrder: this.sortOrder,
      });
    },
    emitCustomers() {
      this.emitToActiveLivewireComponent('layoutsVueSelectedCustomersUpdated', this.selectedCustomers);
    },
    emitCurrentState() {
      this.$nextTick(() => {
        this.emitCustomers();
        this.emitFilters();
      });
    },
    selectAllCustomers() {
      this.selectedCustomers = [];
      this.emitCustomers();
    },
    toggleCustomer(customerId, checked) {
      const id = String(customerId);
      if (checked && !this.selectedCustomers.includes(id)) {
        this.selectedCustomers = [...this.selectedCustomers, id];
      }

      if (!checked) {
        this.selectedCustomers = this.selectedCustomers.filter(selected => selected !== id);
      }

      this.emitCustomers();
    },
    clearAll() {
      this.search = '';
      this.searchProjects = true;
      this.searchProductId = true;
      this.showOnlyFavorites = false;
      this.hideEmptyLayouts = false;
      this.showQaLayouts = false;
      this.selectedCustomers = [];
      this.customerSearch = '';
      this.otherFilters = {
        ID: '',
        Name: '',
        Company: '',
        'Created By': '',
      };
      this.perPage = 10;
      this.sortBy = '';
      this.sortOrder = '';
      this.emitCustomers();
      this.emitFilters();
    },
  },
};
</script>

<style scoped lang="scss">
.layouts-filter-controls {
  display: inline-flex;
  align-items: center;
  gap: var(--lm-gap, 12px);

  .dropdown,
  .input-group,
  #reports-search-input,
  #searchSettings,
  #filterDropdown {
    margin: 0 !important;
  }

  #reports-search-input {
    input.form-control {
      height: var(--lm-control-h, 36px);
      min-width: 13.75rem;
      border: 1px solid var(--lm-border, #d7dde3);
      border-radius: var(--lm-radius, 10px);
      padding-left: 2.25rem;
      background-color: #fafafa !important;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='%236b7785' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='11' cy='11' r='8'/%3E%3Cline x1='21' y1='21' x2='16.65' y2='16.65'/%3E%3C/svg%3E");
      background-position: 12px center;
      background-repeat: no-repeat;
      background-size: 14px 14px;
    }

    .input-group > input.form-control {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-right: 0;
    }

    .layouts-filter-controls__search-clear {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 39px;
      top: 50%;
      z-index: 5;
      width: 28px;
      height: 28px;
      padding: 0 !important;
      transform: translateY(-50%);
      color: #6b7785;
      background: transparent !important;
      border: 0 !important;
      box-shadow: none !important;
      line-height: 1;

      &:hover {
        color: var(--lm-green, #007964);
      }

      i {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        line-height: 1;
      }
    }

    .input-group-append,
    .input-group-append #searchSettings {
      display: flex;
      align-items: center;
    }
  }

  .layouts-top__icon-btn {
    width: 38px;
    height: var(--lm-control-h, 36px);
    padding: 0 !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    border: 1px solid var(--lm-border, #d7dde3);
    border-left: 0 !important;
    border-radius: var(--lm-radius, 10px) !important;
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    background: #fafafa !important;
    color: var(--lm-text, #3b4a5a);
    line-height: 1;

    &:hover {
      background: #f7f9fb !important;
    }

    i {
      display: block;
      line-height: 1;
      font-size: 16px;
      margin: 0 !important;
      padding: 0 !important;
      vertical-align: middle !important;
      transform: translateY(0) !important;
    }
  }

  #searchSettings {
    position: relative;

    form.dropdown-menu {
      min-width: 297px !important;
      position: absolute !important;
      inset: 0 auto auto 0 !important;
      margin: 0 !important;
      transform: translate(0, 36px) !important;
      left: -258px !important;
      right: auto !important;
    }
  }

  #filterDropdown {
    display: flex;
    align-items: center;

    > button.btn {
      height: var(--lm-control-h, 36px);
      border-radius: var(--lm-radius, 10px);
      padding: 0 16px;
      background: var(--lm-green, #007964);
      border-color: var(--lm-green, #007964);
      display: inline-flex;
      align-items: center;
      gap: 8px;
      font-weight: 600;
      font-size: 14px;
      line-height: 1;

      &:hover {
        background: var(--lm-green-hover, #006d52);
        border-color: var(--lm-green-hover, #006d52);
      }

      &:active,
      &:focus,
      &:active:focus {
        background: var(--lm-green, #007964) !important;
        border-color: var(--lm-green, #007964) !important;
        box-shadow: none !important;
      }

      i {
        display: block;
        line-height: 1;
        font-size: 16px;
        margin: 0 !important;
        padding: 0 !important;
        vertical-align: middle !important;
        transform: translateY(0) !important;
      }
    }

    &.show > button.btn {
      background: var(--lm-green, #007964) !important;
      border-color: var(--lm-green, #007964) !important;
      box-shadow: none !important;
    }

    .dropdown-toggle::after {
      display: none;
    }

    .dropdown-menu {
      .form-check-label {
        display: inline-flex;
        align-items: center;
        gap: 12px;
        line-height: 1.2;
      }

      .form-check-input[type="checkbox"] {
        appearance: none;
        -webkit-appearance: none;
        width: 22px;
        height: 22px;
        margin: 0;
        border: 2px solid var(--lm-green, #007964);
        border-radius: 4px;
        background: #fff;
        display: inline-block;
        position: relative;
        flex: 0 0 22px;
        vertical-align: middle;

        &:checked {
          background: var(--lm-green, #007964);
          border-color: var(--lm-green, #007964);
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='white' d='M6.173 12.727 2.2 8.754l1.06-1.06 2.913 2.914L12.74 4.04l1.06 1.06z'/%3E%3C/svg%3E");
          background-position: center;
          background-repeat: no-repeat;
          background-size: 14px 14px;
        }

        &:focus {
          outline: none;
          box-shadow: 0 0 0 2px rgba(31, 143, 122, 0.18);
        }
      }

      &.lm-filters {
        right: 0 !important;
        left: auto !important;
        width: 411px;
        max-width: calc(100vw - 32px);
        padding: 0;
        border-radius: 12px;
        border: 1px solid #e6eaef;
        overflow: hidden;
        box-shadow: 0 10px 24px rgba(16, 24, 40, .10);
      }
    }

    .lm-filters {
      &__body {
        padding: 16px 18px 10px;
      }

      &__toggles {
        display: flex;
        align-items: center;
        gap: 1rem;
        padding-bottom: 12px;
      }

      &__row {
        display: grid;
        grid-template-columns: minmax(min-content, 103px) 1fr;
        margin-bottom: 12px;

        label {
          color: #667085;
          font-weight: 600;
        }

        .form-control {
          height: 40px !important;
          background: #f7f2f2 !important;
          border: 1px solid #e6eaef !important;
          border-radius: 8px !important;
          box-shadow: none !important;
          color: #101828 !important;

          &::placeholder {
            color: #98a2b3 !important;
          }

          &:focus {
            border-color: rgba(31, 143, 122, 0.45) !important;
            box-shadow: 0 0 0 2px rgba(31, 143, 122, 0.14) !important;
            outline: none !important;
          }
        }
      }

      &__footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 18px;
        background: #fff;
        position: relative;

        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 18px;
          right: 18px;
          height: 1px;
          background: #eef2f6;
        }
      }

      &__clear {
        color: #667085;
        font-weight: 600;
        text-decoration: none;

        &:hover {
          color: #475467;
          text-decoration: underline;
        }
      }

      &__active {
        color: #667085;
        font-weight: 600;
      }
    }

    .layouts-customer-filter {
      position: relative;

      &__button {
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-align: left;
      }

      &__menu {
        position: absolute;
        top: calc(100% + 4px);
        left: 0;
        right: 0;
        z-index: 1060;
        max-height: 260px;
        overflow-y: auto;
        padding: 8px 0;
        border: 1px solid #e6eaef;
        border-radius: 8px;
        background: #fff;
        box-shadow: 0 10px 24px rgba(16, 24, 40, .12);
      }

      &__search {
        position: sticky;
        top: 0;
        z-index: 1;
        padding: 8px 10px;
        background: #fff;

        .form-control {
          height: 34px !important;
          border: 1px solid #e6eaef !important;
          border-radius: 8px !important;
          box-shadow: none !important;
          font-size: 13px;
        }
      }

      &__option {
        display: flex;
        align-items: center;
        gap: 8px;
        margin: 0;
        padding: 8px 12px;
        font-weight: 500;
        color: #344054;
        cursor: pointer;

        &:hover {
          background: #f7f9fb;
        }
      }

      &__empty {
        padding: 10px 12px;
        color: #667085;
        font-size: 13px;
      }
    }
  }
}
</style>
